module.exports = __webpack_public_path__ + "static/media/cosplay4.99e5d91d.jpg";